import type { TutorLegalFile } from './interfaces'

import { formatFileSize } from '@shared/ui/other'

import { useTutorLegalStore } from './store'

interface TutorLegalUploadedFilesReturn {
  files: ComputedRef<TutorLegalFile[]>
  removeFile: (id: number) => void
}

export const useTutorLegalUploadedFiles = (): TutorLegalUploadedFilesReturn => {
  const tutorLegalStore = useTutorLegalStore()

  const files = computed<TutorLegalFile[]>(() =>
    tutorLegalStore.getExistingFiles.map(file => ({
      id: file.id,
      name: file.filename,
      size: formatFileSize(file.filesize),
      url: file.view_link,
    })),
  )

  const removeFile = (id: number): void => {
    tutorLegalStore.removeExistingFile(id)
  }

  return {
    files,
    removeFile,
  }
}
